import { render, staticRenderFns } from "./CustomerCorrespondence.vue?vue&type=template&id=a44836fe&"
import script from "./CustomerCorrespondence.vue?vue&type=script&lang=js&"
export * from "./CustomerCorrespondence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports